























import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';
import Auth from '@/layouts/Auth.vue';

@Component({
  name: 'forgot-password',
  components: {
    Auth,
  },
})

export default class ForgotPasswordPage extends Vue {
  $refs!: {
    form: ElForm
  }

  submitting = false

  submitted = false

  formData = {
    password: '',
    passwordRepeat: '',
  }

  validatePass(rule: any, value: string, callback: any): void {
    if (value !== this.formData.passwordRepeat) {
      callback(new Error('Введенные пароли должны совпадать'));
    } else {
      callback();
    }
  }

  validatePassRepeat(rule: any, value: string, callback: any): void {
    if (value !== this.formData.password) {
      callback(new Error('Введенные пароли должны совпадать'));
    } else {
      callback();
    }
  }

  rules = {
    password: [
      {
        type: 'string',
        pattern: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[0-9a-zA-Z]{8,}\w+/,
        message: 'Пароль должен состоять из латинских символов, содержать минимум одну заглавную букву, одну цифру и быть не менее 8 символов длиной',
      },
      { required: true, message: 'Пожалуйста, введите новый пароль', trigger: 'submit' },
      { validator: this.validatePass, trigger: 'submit' },
    ],
    passwordRepeat: [
      { required: true, message: 'Пожалуйста, повторите новый пароль', trigger: 'submit' },
      { validator: this.validatePassRepeat, trigger: 'blur' },
    ],
  }

  submit() {
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.submitting = true;
        setTimeout(() => {
          this.submitted = true;
        }, 1000);
      }
    });
  }
}
